/* ---------- BS-001's surge protection earthed to a bar of its own (#3779, as CP-002's spdbar.ts) ----------
 * -FA1's earth went straight to the earthing busbar's second clamp, three rails down on rail 4. It now goes to -WE2, a small bar
 * right beside -FA1 on rail 1, and -WE2 is bonded to that same clamp (board.ts). A save may hold the old conductor, -WE1:2 to
 * -FA1:PE, which the wiring step would now call wrong. How such a save is read: the save migration in packages/progress uses this
 * (format 37). Self-contained on purpose, as CP-002's: the migration imports this file alone, not BS-001's pack. */

/** The conductor that goes: -FA1's earth straight to the earthing busbar's second clamp. */
export const BS001_SPD_EARTH_OLD: [string, string] = ["WE1:2", "FA1:PE"];
const isOld = (a: unknown, b: unknown) => (a === BS001_SPD_EARTH_OLD[0] && b === BS001_SPD_EARTH_OLD[1]) || (a === BS001_SPD_EARTH_OLD[1] && b === BS001_SPD_EARTH_OLD[0]);

/** A build record without the old conductor: -WE2 is new work, to place beside -FA1 and wire (its two conductors). */
const one = <A extends { ui?: any }>(s: A): A => {
  const b = s?.ui?.build, wires: any[] = Array.isArray(b?.wires) ? b.wires : [];
  const next = wires.filter(w => !isOld(w?.from, w?.to));
  return next.length === wires.length ? s : { ...s, ui: { ...s.ui, build: { ...b, wires: next } } };
};
/** A saved BS-001 project with -FA1's old earth conductor taken off: its own work and each earlier attempt it keeps. */
export function spdBarBs001Save<T extends { ui?: any; attempts?: any[] }>(s: T): T {
  const out = one(s);
  return Array.isArray(s?.attempts) ? { ...out, attempts: s.attempts.map(a => one(a)) } : out;
}
